import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { PresentationProvider } from '../../context/PresentationProvider';
import { WriteAReview } from './WriteAReview.component.js';

export const WriteAReviewWithPresentation = (props) => {
  const { channel } = useContext(ExperienceContext);
  const useCondensedLayout = props?.forceCondensedLayout || props?.channel === 'mobile' || channel === 'mobile';

  return (
    <PresentationProvider useCondensedLayout={useCondensedLayout}>
      <WriteAReview { ...props } />
    </PresentationProvider>
  )
}
